<template>
  <section
    ref="bannerRef"
    class="w-full h-screen-3/5 md:h-screen flex justify-center items-center banner-wrapper"
    :style="{ ...bgImageStyle }"
  >
    <div
      class="block mx-auto w-320 sm:w-400 md:w-600 mb-16 text-base banner-brand__content"
    >
      <img
        v-if="heroImage"
        :src="heroImage"
        :style="{
          ...heroImageStyle,
        }"
        alt="heroImage"
      />
      <h1
        class="text-8xl text-center mb-6 tracking-wider hero-text"
        v-if="heroText"
      >
        {{ heroText }}
      </h1>
      <p
        class="mx-auto text-5xl text-center tagline"
        v-if="tagline"
        :style="{width: tagline.length + 'em', animationTimingFunction: `steps(${tagline.length}),steps(1)`}"
      >
        {{ tagline }}
      </p>
      <div
        class="i-tabler-chevrons-down text-4xl absolute left-1/2 bottom-5 animate-bounce cursor-pointer text-primary compact-down"
        @click="downFn"
      ></div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useData, withBase } from 'vitepress';

const { frontmatter } = useData();
const bannerRef = ref<HTMLElement | null>(null);
const heroImage = computed(() => {
  return frontmatter.value?.banner?.heroImage
    ? withBase(frontmatter.value?.banner?.heroImage)
    : null;
});

const heroImageStyle = computed(
  () => frontmatter.value.banner.heroImageStyle || {}
);
const heroText = computed(() => frontmatter.value?.banner?.heroText || '')
const tagline = computed(() => frontmatter.value?.banner?.tagline || '')

const bgImageStyle = computed(() => {
  const { bgImageStyle, bgImage } = frontmatter.value?.banner || {};

  const initBgImageStyle = bgImage
    ? {
        textAlign: 'center',
        overflow: 'hidden',
        background: `url(${withBase(bgImage)}) center/cover no-repeat`,
      }
    : {};

  return bgImageStyle
    ? { ...initBgImageStyle, ...bgImageStyle }
    : initBgImageStyle;
});

const downFn = function () {
  const bannerHeight = bannerRef.value?.offsetHeight || 0;
  window.scrollTo(0, bannerHeight - 50);
};
</script>
<style lang="scss">
@keyframes typing {
 from { width: 0 }
}
@keyframes caret {
 50% { border-color: transparent; }
}
.tagline {
 width: 15em; /* 文本的宽度 */
 overflow: hidden;
 white-space: nowrap;
 border-right: .05em solid;
 animation: typing 6s steps(15),
 caret 1s steps(1) infinite;
  text-shadow: 0 1px hsl(0, 0%, 85%), 0 2px hsl(0, 0%, 80%),
    0 3px hsl(0, 0%, 75%), 0 4px hsl(0, 0%, 70%), 0 5px hsl(0, 0%, 65%),
    0 5px 10px black;
}
</style>
